/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Flyertool1Inputs */

const en_flyertool1 = /** @type {(inputs: Flyertool1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flyer`)
};

const de_flyertool1 = /** @type {(inputs: Flyertool1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flyer`)
};

/**
* | output |
* | --- |
* | "Flyer" |
*
* @param {Flyertool1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const flyertool1 = /** @type {((inputs?: Flyertool1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Flyertool1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_flyertool1(inputs)
	return de_flyertool1(inputs)
});
export { flyertool1 as "flyerTool" }